import React, { useState, useEffect } from 'react';
import { IconButton, Box } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  // Show the button when the user scrolls down 100px
  const toggleVisibility = () => {
    if (window.scrollY > 100) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        zIndex: 1000,
        display: visible ? 'flex' : 'none',
      }}
    >
      <IconButton
        onClick={scrollToTop}
        sx={{
          backgroundColor: 'black',
          color: '#F3F6F8',
          '&:hover': {
            backgroundColor: '#F3F6F8',
            color: '#6e6a6a',
          },
        }}
      >
        <KeyboardArrowUp />
      </IconButton>
    </Box>
  );
};

export default ScrollToTop;
